import type { IConsentGroup } from '../types/IConsentConfig';

export const videoConsentGroup: IConsentGroup = {
  key: 'video',
  title: 'Video-Einbettung',
  items: [
    {
      title: 'Vimeo',
      description: 'Einbettung von auf Vimeo gehosteten Videos',
      key: 'allowVimeo',
    },
    {
      title: 'YouTube',
      description: 'Einbettung von auf YouTube gehosteten Videos',
      key: 'allowYoutube',
    },
  ],
};
